import { createContext, PropsWithChildren, useContext, useId } from 'react';

type CheckboxContextData = {
  id: string;
};

const CheckboxContext = createContext({} as CheckboxContextData);

export function CheckboxContextProvider({ children }: PropsWithChildren) {
  const id = useId();

  return (
    <CheckboxContext.Provider value={{ id }}>
      {children}
    </CheckboxContext.Provider>
  );
}

export function useCheckbox() {
  const context = useContext(CheckboxContext);

  if (!context) {
    throw new Error('useCheckbox must be used within a CheckboxProvider');
  }

  return context;
}
